import { render, staticRenderFns } from "./StockoutsTable.vue?vue&type=template&id=449508fc"
import script from "./StockoutsTable.vue?vue&type=script&lang=js"
export * from "./StockoutsTable.vue?vue&type=script&lang=js"
import style0 from "./StockoutsTable.vue?vue&type=style&index=0&id=449508fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports